var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 1.27325L1.27337 0.333252L8.33337 7.39325V2.99992H9.66671V9.66659H3.00004V8.33325H7.39337L0.333374 1.27325Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossIcon);
export default __webpack_public_path__ + "static/media/loss-icon.66da447cfe182943a26112d3b2f9a704.svg";
export { ForwardRef as ReactComponent };